import { createApp } from "vue";
import App from "./App.vue";
import router from '@/router';
import { createPinia } from 'pinia';
import mixin from './mixin';

import '@/assets/css/main.scss';

const app = createApp(App);
const pinia = createPinia()

pinia.use(({ store }) => {
    store.$router = router
});

app.use(router);
app.use(pinia);
app.mixin(mixin);
app.mount("#app");
